import { render, staticRenderFns } from "./setPOUserDialog.vue?vue&type=template&id=956d28be"
import script from "./setPOUserDialog.vue?vue&type=script&lang=js"
export * from "./setPOUserDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports